'use client';

import get from 'lodash/get';
import { FiTrash2 } from 'react-icons/fi';

import Label from '~/shared/components/form-fields/label/label';

import '~/shared/components/form-fields/image-field/image-field.scss';

import imageType from '../../../../assets/image-type.png';

type ImageFieldPropsType = {
  path: string;
  label: string;
  name: string;
  value: string;
  meta: {
    touched: boolean;
    error: string;
  };
  changeStateOfConfirmRemovingModal: ({ isShowed, itemKey }: { isShowed: boolean; itemKey: string }) => void;
};

const ImageField = ({
  value,
  name,
  label,
  setValue,
  getValues,
  changeStateOfConfirmRemovingModal,
  path,
}: ImageFieldPropsType) => {
  return path ? (
    <img alt={name} src={path} />
  ) : (
    <div className="image-field">
      {label && <Label className="image-field__label">{label}</Label>}
      <div className="image-field__content">
        <div className="image-field__image">
          {value && <img alt={name} src={get(value, 'path') ? get(value, 'path') : imageType.src} />}
        </div>
        {value && (
          <div className="image-field__delete-icon">
            <FiTrash2
              onClick={() => {
                changeStateOfConfirmRemovingModal({
                  itemKey: value,
                });
              }}
              className="image-field__delete-icon--red"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageField;
